function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m23.967,34.025h-17.967c-3.309,0-6,2.691-6,6v17.975c0,3.309 2.691,6 6,6h17.967c3.309,0 6-2.691 6-6v-17.975c0-3.308-2.692-6-6-6zm2,23.975c0,1.103-0.896,2-2,2h-17.967c-1.104,0-2-0.897-2-2v-17.975c0-1.103 0.896-2 2-2h17.967c1.104,0 2,0.897 2,2v17.975z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m58,34.025h-17.969c-3.309,0-6,2.691-6,6v17.975c0,3.309 2.691,6 6,6h17.969c3.309,0 6-2.691 6-6v-17.975c0-3.308-2.691-6-6-6zm2,23.975c0,1.103-0.898,2-2,2h-17.969c-1.102,0-2-0.897-2-2v-17.975c0-1.103 0.898-2 2-2h17.969c1.102,0 2,0.897 2,2v17.975z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m23.967,0h-17.967c-3.309,0-6,2.691-6,6v17.969c0,3.309 2.691,6 6,6h17.967c3.309,0 6-2.691 6-6v-17.969c0-3.309-2.692-6-6-6zm2,23.969c0,1.103-0.896,2-2,2h-17.967c-1.104,0-2-0.897-2-2v-17.969c0-1.103 0.896-2 2-2h17.967c1.104,0 2,0.897 2,2v17.969z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58,0H40.031c-3.309,0-6,2.691-6,6v17.969c0,3.309,2.691,6,6,6H58c3.309,0,6-2.691,6-6V6    C64,2.691,61.309,0,58,0z M60,23.969c0,1.103-0.898,2-2,2H40.031c-1.102,0-2-0.897-2-2V6c0-1.103,0.898-2,2-2H58    c1.102,0,2,0.897,2,2V23.969z"
})));

var SvgListGrid = function SvgListGrid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgListGrid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list-grid.3385d19a.svg";
export { ForwardRef as ReactComponent };